export default function WhoWeAreSection() {
  return (
    <section className="bg-white text-foreground-950 pt-20 md:pt-28">
      <div className="wrap text-center">
        <h2 className="mx-auto max-w-[760px] font-display font-normal text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.12] tracking-[-0.015em] text-foreground-950">
          Great businesses are built through people.
        </h2>
        <div className="mt-8 md:mt-10 mx-auto max-w-[600px] space-y-4 text-[16px] md:text-[17px] leading-[1.6] text-foreground-800">
          <p>The right conversations, perspective, and talent can change what is possible.</p>
          <p>
            Morrow People partners with organisations navigating growth, change, and the people decisions that shape their future.
          </p>
        </div>
      </div>
      <div className="wrap mt-20 md:mt-20">
        <div className="mx-auto max-w-[1280px] border-t-0 md:border-t border-foreground-950/80"></div>
      </div>
      <div className="h-10 md:h-6"></div>
    </section>
  );
}